const constants = {
  ACTIONS: {
    GET_IMAGINE_ADD_SUCCESS:"GET_IMAGINE_ADD_SUCCESS",
    GET_IMAGINE_ADD_FAILED:"GET_IMAGINE_ADD_FAILED",
    GET_IMAGINE_DATA_SUCCESS:"GET_IMAGINE_DATA_SUCCESS",
    GET_IMAGINE_DATA_FAILED:"GET_IMAGINE_DATA_FAILED",
    GET_IMAGINE_PACK_DATA_SUCCESS:"GET_IMAGINE_PACK_DATA_SUCCESS",
    GET_IMAGINE_PACK_DATA_FAIL:"GET_IMAGINE_PACK_DATA_FAIL",
    GET_IMAGINE_PACK_DATA_SLUG_SUCCESS:"GET_IMAGINE_PACK_DATA_SLUG_SUCCESS",
    GET_IMAGINE_PACK_DATA_ID_SUCCESS:"GET_IMAGINE_PACK_DATA_ID_SUCCESS",
    GET_SUB_CENTER:"GET_SUB_CENTER",
    GET_NEARBY_CITIES:"GET_NEARBY_CITIES",
    POST_LEAD_USER_SUCCESS: "POST_LEAD_USER_SUCCESS",
    POST_LEAD_USER_FAILED: "POST_LEAD_USER_FAILED"
  },
};
export default constants;
